<template>
  <span class="flex items-baseline font-bold text-base whitespace-nowrap">
    {{ calcFxRate ? `${currencySymbol}${parse(amount).euros}` : "€" + parse(amount).euros }}.{{ parse(amount).cents }}
  </span>
</template>
<script setup>
import { useUserStore } from "@/store/user.js";
import { currencies } from "@xs2event/js-lib";
import { computed } from "vue";

const userStore = useUserStore();
const props = defineProps({
  amount: { default: 0 },
  calcFxRate: { default: false },
  originalCurrency: { default: null },
  netAmount: { default: null },
});

const currencySymbol = computed(() => {
  const currentCurrency = currencies.filter((c) => c.code === userStore.selectedCurrency)[0];
  if (currentCurrency) {
    return currentCurrency.symbol ? currentCurrency.symbol : currentCurrency.code;
  } else {
    return userStore.selectedCurrency;
  }
});

const parse = (amount) => {
  if (props.calcFxRate) {
    const fxAmount = userStore.calcFx(amount, props.originalCurrency, props.netAmount);
    const [euros, cents] = (fxAmount / 100).toFixed(2).split(".");
    return { euros, cents };
  } else {
    const [euros, cents] = (amount / 100).toFixed(2).split(".");
    return { euros, cents };
  }
};
</script>
